program DOPG_Time_WebApp;

uses
  Vcl.Forms,
  WEBLib.Forms,
  U_Main in 'U_Main.pas'{*.html},
  U_Model in 'U_Model.pas',
  U_DateTimeHelper in 'Helpers\U_DateTimeHelper.pas',
  WebScannerForm in 'WebScannerForm.pas',
  U_ParseHelper in 'Helpers\U_ParseHelper.pas',
  U_ApiClient in 'U_ApiClient.pas';

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TForm_Main, Form_Main);
  Application.CreateFormDirect(TfrmScanner, frmScanner);
  Application.Run;
end.
